import { useQuery } from "@apollo/client";
import { useEffect } from "react";

import {
  Dashboard,
  DashboardDocument,
} from "../../../models/autogenerated-deliveryService-gql/graphql";

interface UseDashboardQueryProps {
  skip?: boolean;
  dataAction: (data: Dashboard) => void;
  errorAction?: () => void;
}

const useDashboardQuery = (props: UseDashboardQueryProps) => {
  const { skip = false, dataAction } = props;

  const query = useQuery(DashboardDocument, {
    skip,
    fetchPolicy: "network-only",
  });

  const dashboard = query.data?.dashboard;

  useEffect(() => {
    if (!dashboard) return;

    dataAction(dashboard);
  }, [dashboard]);

  return query;
};

export default useDashboardQuery;
